import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../root';
const FUNCTION_CODE = 'CREATE_SUBSIDIARY';

export async function createSubsidiary(
    userToken: string,
    newSubsidiary: Record<string, unknown>
) {
    try {
        const response = await axios({
            method: 'post',
            url: `${URL}/subsidiaries/`,
            data: newSubsidiary,
            headers: {
                Accept: 'application/json',
                Authorization: `Token ${userToken}`
            }
        });

        return response.data;
    }
    catch (error: any) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur de création d\'une méthode de paiement',
            error: error
        });
    }
}
